import {Stack, CardMedia} from "@mui/material"
import { type FC} from "react"

type Props = {
  videoURL?: any
}

const VideoFrame: FC<Props> = (props) => {

  return (
    <Stack
      component="section"
      spacing={1}
      position="relative"
      style={{
        padding: "8px",
        borderRadius: "8px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "#cdcdcd",
        height: "100%"
      }}
    >
        <CardMedia
         component={"iframe"}
         style={{
            height: "100%"
         }}
         src={props.videoURL}>
        </CardMedia>
    </Stack>
  )
}
export default VideoFrame
